import React from "react";
import { AppContext } from "../../contexts/AppContext";
import Card from "../../components/page/Card";
import TabList from "../../components/Tab/TabList";
import TabButton from "../../components/Tab/TabButton";
import TabContent from "../../components/Tab/TabContent";
import SuporteDataTables from "./Suporte/SuporteDataTables";
import useApi from "../../hooks/useApi";
import SuporteApiClient from "../../api/suporte";
import ButtonRounded from "../../components/buttons/ButtonRounded";
import NovoTicketModal from "./Suporte/NovoTicketModal";
import CommonSwal from "../../components/Swal/commonSwal";
import ErrorSwal from "../../components/Swal/errorSwal";
import Validation from "../../helpers/Validation";
import VisualizarTicketModal from "./Suporte/VisualizarTicketModal";
import { FaPlus } from "react-icons/fa6";
import TabPane from "../../components/Tab/TabPane";

function Suporte() {
  const [linhas, setLinhas] = React.useState([]);
  const [linhasFechados, setLinhasFechados] = React.useState([]);
  const [novoTicketModal, setNovoTicketModal] = React.useState(false);
  const [fechado, setFechado] = React.useState(false);
  const [visualizarTicketModal, setVisualizarTicketModal] =
    React.useState(false);
  const [values, setValues] = React.useState({});
  const [ticket, setTicket] = React.useState({});
  const { session } = React.useContext(AppContext);

  const { request: getTickets, data: ticketsResponse } = useApi(
    SuporteApiClient.listTickets
  );
  const postTicketApi = useApi(SuporteApiClient.postTicket);
  const getTicketApi = useApi(SuporteApiClient.getTicket);
  const putTicketApi = useApi(SuporteApiClient.putTicket);

  //Busca tickets ao renderizar tela
  React.useEffect(() => {
    getTickets();
  }, [getTickets]);

  //Define o retorno da api nos valores das linhas das tabelas
  React.useEffect(() => {
    if (!ticketsResponse) return;
    const ticketsAbertos = ticketsResponse.filter(
      (ticket) => ticket.status === 1
    );
    setLinhas(ticketsAbertos);

    const ticketsFechados = ticketsResponse.filter(
      (ticket) => ticket.status === 0
    );
    setLinhasFechados(ticketsFechados);
  }, [ticketsResponse]);

  const togNovoTicketModal = () => {
    setValues({ uid_usuario: session.user_guid });
    setNovoTicketModal(true);
  };

  const togVisualizarTicketModal = async (ticket_id, fechado) => {
    const response = await getTicket(ticket_id);
    if (response) return;
    setValues({ uid_usuario: session.user_guid });
    setFechado(fechado);
    setVisualizarTicketModal(true);
  };

  const salvaNovoTicket = async () => {
    const formData = new FormData();
    formData.append("uid_usuario", values.uid_usuario);
    formData.append("modulo", values.modulo);
    formData.append("titulo", values.titulo);
    formData.append("texto", values.texto);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await postTicketApi.request(formData);
    if (!response) return;

    CommonSwal({
      title: "Ticket enviado com sucesso!",
      icon: "success",
    }).then(async () => {
      await getTickets();
      setNovoTicketModal(false);
    });
  };

  const getTicket = async (ticket_id) => {
    const response = await getTicketApi.request(ticket_id);
    if (!response) return true;
    response.historico = JSON.parse(response.historico);
    setTicket(response);
    return false;
  };

  const salvarResposta = async () => {
    const { uid_usuario, resposta } = values;
    const { id } = ticket;
    const formData = new FormData();
    formData.append("uid_usuario", uid_usuario);
    formData.append("resposta", resposta);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await putTicketApi.request(id, formData);
    if (!response) return;
    setValues({ uid_usuario: session.user_guid });
    await getTicket(id);
    await getTickets();
  };

  const concluirTicket = async (id) => {
    const formData = new FormData();
    formData.append("status", 0);
    formData.append("uid_usuario", session.user_guid);

    const response = await putTicketApi.request(id, formData);
    if (!response) return;
    CommonSwal({
      title: "Ticket fechado com sucesso!",
      icon: "success",
    }).then(async () => {
      await getTickets();
    });
  };

  return (
    <>
      <Card>
        <div className="row mb-3">
          <div className="col-12 text-end">
            <ButtonRounded
              onClick={() => {
                togNovoTicketModal();
              }}
              color="success"
              icon={<FaPlus />}
            >
              Novo ticket
            </ButtonRounded>
          </div>
        </div>
        <TabList>
          <TabButton href="tickets-abertos" ativo={true}>
            Tickets em aberto
          </TabButton>
          <TabButton href="tickets-fechados">Tickets fechados</TabButton>
        </TabList>
        <TabContent>
          <TabPane id="tickets-abertos" ativo={true}>
            <SuporteDataTables.Abertos
              linhas={linhas}
              togVisualizarTicketModal={togVisualizarTicketModal}
              concluirTicket={concluirTicket}
            />
          </TabPane>
          <TabPane id="tickets-fechados">
            <SuporteDataTables.Fechados
              linhas={linhasFechados}
              togVisualizarTicketModal={togVisualizarTicketModal}
            />
          </TabPane>
        </TabContent>
      </Card>
      <NovoTicketModal
        ticketModalHook={{ novoTicketModal, setNovoTicketModal }}
        valuesHook={{ values, setValues }}
        salvaNovoTicket={salvaNovoTicket}
      />
      <VisualizarTicketModal
        ticketModalHook={{ visualizarTicketModal, setVisualizarTicketModal }}
        valuesHook={{ values, setValues }}
        ticket={ticket}
        fechado={fechado}
        salvarResposta={salvarResposta}
      />
    </>
  );
}

export default Suporte;
